/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/destructuring-assignment */
import 'rc-notification/assets/index.css';
import React, { useRef, useState } from "react";
import { Row, Col } from 'reactstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import Notification from 'rc-notification';
import { Table, Button, Popconfirm, Upload } from "antd";
import Select from 'react-select';
import * as XLSX from 'xlsx';
import SmallLoader from '../../../shared/components/SmallLoader';
import SubscriberResizableTable from './SubscriberResizableTable';
import { tableHeaderDataForUploadSubscriber as tableHeaderData } from "../helper";

const ExcelImport = ({ countryOption: propCountryOption = [] }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const inputRef = useRef();

  // Get country options from props or route state
  const countryOption = propCountryOption.length > 0 
    ? propCountryOption 
    : (location.state?.countryOption || []);
  
  // State variables
  const [cols, setCols] = useState([]);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCountryOptions, setSelectedCountryOptions] = useState();
  const [errorMessage, setErrorMessage] = useState(null);
  
  // Instance variables (using useRef to maintain across renders)
  const tableData = useRef({ tableHeaderData: [], tableRowsData: [] });
  const isEmptyCell = useRef(false);
  const isError = useRef(false);
  const errorMessageRef = useRef('');
  const cogsNumberCount = useRef(0);
  const emptyCellCount = useRef(0);
  const emptyCellErrorMessage = useRef('');
  const cogsErrorMessage = useRef('');
  
  const regexp = /^\$?[0-9.,]+$/;
  
  const columns = [
    {
      title: "ASIN",
      dataIndex: "asin",
      editable: true,
      width: 180
    },
    {
      title: "SKU",
      dataIndex: "sku",
      editable: true,
      width: 180
    },
    {
      title: "Product name",
      dataIndex: "productName",
      editable: true,
      width: 220
    },
    {
      title: "Subscriptions Count",
      dataIndex: "activeSubscriptions",
      editable: true,
      width: 200
    },
    {
      title: "Country",
      dataIndex: "country",
      editable: true,
      width: 200
    }
  ];

  const handleSave = (row) => {
    const newData = [...rows];
    const index = newData.findIndex(item => row.ASIN === item.ASIN);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row
    });
    setRows(newData);
  };

  const clearData = () => {
    setRows([]);
    setSelectedCountryOptions([]);
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  const handleImportClick = () => {
  // Check if country is selected before opening file dialog
  if (!selectedCountryOptions || !selectedCountryOptions.value) {
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'Please select a country before importing the Excel file!',
        duration: 5,
        closable: true,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 50
      });
    });
    setErrorMessage("Please select a country before importing the Excel file!");
    return;
  }
  
  // If country is selected, trigger the file input
  if (inputRef.current) {
    inputRef.current.click();
  }
};

  // Updated Excel import function using XLSX
  const onImportExcel = (event) => {
    const { files } = event.target;
    // First check if country is selected
    // if (!selectedCountryOptions || !selectedCountryOptions.value) {
    //   Notification.newInstance({}, (notification) => {
    //     notification.notice({
    //       content: 'Please select a country before importing the Excel file!',
    //       duration: 5,
    //       closable: true,
    //       style: {top: 120, fontWeight: "bold"},
    //       maxCount: 50
    //     });
    //   });
    //   setErrorMessage("Please select a country before importing the Excel file!");
      
    //   // Reset the file input
    //   if (inputRef.current) {
    //     inputRef.current.value = "";
    //   }
    //   return false;
    // }
    
    if (files.length === 1) {
      // Check file type
      if (!(files[0].type === "application/vnd.ms-excel" || 
      files[0].type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) 
      {
        Notification.newInstance({}, (notification) => {
          notification.notice({
            content: 'Unknown file format. Only Excel files are uploaded!',
            duration: 5,
            closable: true,
            style: {top: 120, fontWeight: "bold"},
            maxCount: 50
          });
        }); 
        setErrorMessage("Unknown file format. Only Excel files are uploaded!");
        return false;
      }

      // Read file using XLSX
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          
          // Get first worksheet
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          
          // Convert to JSON
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          
          if (jsonData.length < 2) {
            Notification.newInstance({}, (notification) => {
              notification.notice({
                content: 'No data found in file!',
                duration: 10,
                style: {top: 120, fontWeight: "bold"},
                maxCount: 50
              });
            });
            return;
          }

          const newRows = [];
          
          // Reset error tracking
          isError.current = false;
          cogsNumberCount.current = 0;
          cogsErrorMessage.current = '';
          const getTodayAtMidnight = () => {
              const today = new Date();
              const year = today.getFullYear();
              const month = String(today.getMonth() + 1).padStart(2, '0');
              const day = String(today.getDate()).padStart(2, '0');
              return `${year}-${month}-${day}T00:00:00.000`;
          };
          
          // Process data rows (skip header row)
          jsonData.slice(1).forEach((row, index) => {
            if (row && row.length > 0) {
              // Helper function to safely convert values to string
              const safeString = (value) => {
                if (value === null || value === undefined || value === '') {
                  return '';
                }
                return String(value);
              };

              // Check if row has any data in the first 5 columns
              if (row[0] !== undefined || row[1] !== undefined ||
                  row[3] !== undefined || row[11] !== undefined) {     

                newRows.push({
                  asin: safeString(row[0]),
                  sku: safeString(row[1]),                             
                  productName: safeString(row[3]),
                  activeSubscriptions: safeString(row[11]),
                  country: selectedCountryOptions?.value,
                  week1StartDate: getTodayAtMidnight(),
                });
              }
            }
          });

          // Show error notification if there were validation issues
          if (isError.current === true) {
            errorMessageRef.current = cogsErrorMessage.current;
            Notification.newInstance({}, (notification) => {
              notification.notice({
                content: <span>{errorMessageRef.current}</span>,
                duration: 10,
                onClose() {
                  console.log('closable close');
                },
                closable: true,
                onClick() {
                  console.log('clicked!!!');
                },
                style: {top: 120, fontWeight: "bold"},
              });
            }); 
          } else {
            isError.current = false;
            isEmptyCell.current = false;
          }

          if (newRows.length === 0) {
            Notification.newInstance({}, (notification) => {
              notification.notice({
                content: 'No data found in file!',
                duration: 10,
                style: {top: 120, fontWeight: "bold"},
                maxCount: 50
              });
            });            
          } else {
            setCols(jsonData[0] || []); // Headers
            setRows(newRows);
            setErrorMessage(null);
          }
          
        } catch (error) {
          console.error('Error reading file:', error);
          Notification.newInstance({}, (notification) => {
            notification.notice({
              content: 'Error reading file. Please check file format.',
              duration: 10,
              style: {top: 120, fontWeight: "bold"},
              maxCount: 50
            });
          });
        }
      };
      
      reader.readAsArrayBuffer(files[0]);
    } else {
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'No file uploaded!',
          duration: 10,
          style: {top: 120, fontWeight: "bold"},
          maxCount: 50
        });
      });
      setErrorMessage("No file uploaded!");
      return false;
    }
    return false;
  }; 

  const handleSubmit = async () => {
    setIsLoading(true);
    console.log("submitting: ", rows);
    
    const token = localStorage.getItem('easydev');
    const requestOptions = {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        Authorization: token 
      },
      body: JSON.stringify(rows)
    };
    
    try {
      const response = await fetch('https://rss.getrael.com/api/subscriber/import', requestOptions);
      const data = await response.json();
      
      if (data.code === '200') {
        setIsLoading(false);
        navigate('/amazon/subscribers');
      } else if (data.code === '403') {
        setIsLoading(false);
        navigate('/login');
      } else {
        setIsLoading(false);
        Notification.newInstance({}, (notification) => {
          notification.notice({
            content: 'Subscribers not uploaded, Please try again!',
            duration: 10,
            style: {top: 120, fontWeight: "bold"},
            maxCount: 50
          });
        });
        console.log("Subscribers not uploaded, Please try again!");
      }
    } catch (error) {
      setIsLoading(false);
      console.error('Error submitting data:', error);
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'Error submitting data. Please try again!',
          duration: 10,
          style: {top: 120, fontWeight: "bold"},
          maxCount: 50
        });
      });
    }
  };

  const handleDelete = (key) => {
    const newRows = [...rows];
    setRows(newRows.filter(item => item.key !== key));
  };

  const handleAdd = () => {
    const newData = {
      key: rows.length,
      name: "User's name",
      age: "22",
      gender: "Female"
    };
    setRows([newData, ...rows]);
  };

  const changeFilterForCountry = (selectedOptions) => {
    setSelectedCountryOptions(selectedOptions || []);
  };

  // Process country options for the Select component
  const sortedCountryOptions = countryOption.map(country => ({
    value: country.value || country,
    label: country.label || country
  }));

  const components = {
    body: {}
  };

  const finalColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: record => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: handleSave
      })
    };
  });

  return (
    <>
      <Col md={12}>      
        <Row>   
          <Col md="2">
            <div className="form__form-group mb-0 mt-0">
              <span className="form__form-group-label">Country</span>
              <div className="form__form-group-field">
                <Select
                  value={selectedCountryOptions}
                  options={countryOption}
                  clearable={false}
                  placeholder="Select "
                  className="select_filter"
                  onChange={changeFilterForCountry}
                  classNamePrefix="react-select"                  
                />
              </div>
            </div>
          </Col>          
          <Col md="6">
              <button 
                className="btn btn-sm btn-primary"
                style={{ marginTop: 16 }}
                onClick={handleImportClick}>
                Import Excel File
              </button>

              <input
                ref={inputRef}
                type="file"
                accept=".xlsx,.xls"
                onChange={onImportExcel}
                style={{ display: 'none' }}
              />
            &nbsp;<Button 
              className="btn btn-sm btn-danger"
              style={{ marginTop: 16 }}
              onClick={clearData}
            >            
              &nbsp;Clear
            </Button> 
          </Col>
          <Col md="4" align="right">
            {rows.length > 0 && (
              <>               
                <Button
                  onClick={handleSubmit}
                  size="large"
                  type="primary"
                  className="btn btn-primary btn-sm"
                  disabled={isEmptyCell.current}
                  style={{ marginBottom: 16, marginLeft: 10, marginTop: 16 }}
                >
                  Submit Data
                </Button>
              </>
            )}
            <Button
              onClick={() => navigate('/amazon/subscribers')}
              size="large"
              type="danger"
              className="btn btn-primary btn-sm"
              style={{ marginBottom: 16, marginLeft: 10, marginTop: 16 }}
            >
             Back To Subscribers
            </Button>
          </Col>       
        </Row>
        <Row>
          <Col md={12} lg={12}>
            {isLoading ? (
              <>                 
                <div
                  style={{ minHeight: '200px' }}
                  className="row align-items-center justify-content-center"
                >
                  <SmallLoader loading={isLoading} />
                </div>
              </>
            ) : (
              <SubscriberResizableTable 
                customClass="pt-0" 
                reactTableData={{tableHeaderData}} 
                data={rows} 
              />
            )}
          </Col>
        </Row>       
      </Col>
    </>
  );
};

export default ExcelImport;